import React, { useState } from "react";
import { BrowserRouter } from 'react-router-dom'
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PageLayout } from "./components/PageLayout";
import { ProfileData } from "./components/ProfileData";
import { callMsGraph } from "./graph";
import Button from "react-bootstrap/Button";
import { environment } from "./Environment";

import "./css/App-qa.css";
//import "./css/App-uat.css";
//import "./css/App-prod.css";

/**
 * Renders information about the signed-in user or a button to retrieve data about the user
 */
const ProfileContent = () => {
    console.log(environment.env)

    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);


    function RequestProfileData() {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            callMsGraph(response.accessToken).then(response => {
                setGraphData(response)
                console.log(`response: ${response}`)
            });
        });
    }

    console.log("accounts: " + accounts)

    console.log("accounts[0].username: " + accounts[0].username)

    if (!!accounts[0].username) {
        var encusername = btoa(accounts[0].username)
        encusername = btoa(encusername)

        window.location = `${environment.url.AUTH_URL}/Account/SsoSpaLogin?ssologintoken=${encusername}`;
    }

    return (
        <>
            <BrowserRouter basename="/sso">
                <h6 className="card-title">Signing you in. Please Wait... <span style={{ display: 'none' }}>{accounts[0].name}</span></h6>
                {graphData ?
                    <ProfileData style={{ display: "none" }} graphData={graphData} />
                    :
                    <Button style={{ display: "none" }} variant="secondary" onClick={RequestProfileData}>Request Profile Information</Button>
                }
            </BrowserRouter>
        </>
    );
};

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = () => {
    return (
        <div className="App">
            <AuthenticatedTemplate>
                <ProfileContent />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>

            </UnauthenticatedTemplate>
        </div>
    );
};

export default function App() {
    return (
        <PageLayout>
            <MainContent />
        </PageLayout>
    );
}
